// extracted by mini-css-extract-plugin
export default {"box":"qudmzGOoOTbRGkjrKe6R","mealPlanName":"zix_tmiwUKUcxDW2AmtD","mealEditActions":"fP3pwQQ_J4YTWBWTSS22"};